export const MOVE_FORWARD_VERSION = 2;
export const MOVE_FORWARD_USER_PREFERENCE = "userPreference";
export const MOVE_FORWARD_INHERIT = "inherit";

const CHILD_SCOPES = new Set(["list", "section"]);

function getScopeDefault(scope) {
	return CHILD_SCOPES.has(scope)
		? MOVE_FORWARD_INHERIT
		: MOVE_FORWARD_USER_PREFERENCE;
}

function normalizeAuthoredValue(value) {
	if (value === true || value === "true") {
		return true;
	}
	if (value === false || value === "false") {
		return false;
	}
	if (value === MOVE_FORWARD_USER_PREFERENCE) {
		return MOVE_FORWARD_USER_PREFERENCE;
	}
	if (value === MOVE_FORWARD_INHERIT) {
		return MOVE_FORWARD_INHERIT;
	}
	return undefined;
}

export function normalizeMoveForward(source = {}, scope = "activity") {
	const parsedVersion = Number(source && source.moveForwardVersion);
	const requestedValue = source && source.moveForward;
	const defaultValue = getScopeDefault(scope);

	// Preserve a newer contract verbatim so an older authoring client cannot
	// destroy values it does not understand.
	if (Number.isInteger(parsedVersion) && parsedVersion > MOVE_FORWARD_VERSION) {
		return {
			moveForwardVersion: parsedVersion,
			moveForward: requestedValue
		};
	}

	const normalizedValue = normalizeAuthoredValue(requestedValue);
	const isCurrentVersion = parsedVersion === MOVE_FORWARD_VERSION;
	const validForScope = normalizedValue !== undefined
		&& (scope === "activity" ? normalizedValue !== MOVE_FORWARD_INHERIT : true);

	let moveForward = defaultValue;
	if (isCurrentVersion && validForScope) {
		// Version 2 is the first contract where false is an unambiguous author choice.
		moveForward = normalizedValue;
	} else if (
		// Preserve meaningful legacy values while migrating ambiguous false/unset
		// values to the new scope default.
		normalizedValue === true
		|| normalizedValue === MOVE_FORWARD_USER_PREFERENCE
		|| (CHILD_SCOPES.has(scope) && normalizedValue === MOVE_FORWARD_INHERIT)
	) {
		moveForward = normalizedValue;
	}

	return {
		moveForwardVersion: MOVE_FORWARD_VERSION,
		moveForward
	};
}

function applyMoveForwardMigrationToChildren(children) {
	if (!Array.isArray(children)) {
		return;
	}

	children.forEach((node) => {
		if (!node || typeof node !== "object") {
			return;
		}

		if (node.type === "list" || node.type === "section") {
			Object.assign(node, normalizeMoveForward(node, node.type));
		}
		applyMoveForwardMigrationToChildren(node.children);
	});
}

export function applyMoveForwardMigration(target) {
	if (!target || typeof target !== "object") {
		return target;
	}

	Object.assign(target, normalizeMoveForward(target, "activity"));
	applyMoveForwardMigrationToChildren(target.children);
	return target;
}
